import { cx } from '@linaria/core';
import { useRef, useMemo } from 'react';
import { usePageContext } from '../../../../context.js';
import { wrapper, scroller, table, thead, cellContent, cell, tableHeadingCell } from './_task.in-table.style.js';
import { Row } from './molecule.row.js';
import { transformContentToRows } from './util.transform-content-to-rows.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function WriteAnswersInTableTask(props) {
  const pageContext = usePageContext();
  const tableRef = useRef(null);
  const rows = useMemo(() => transformContentToRows(props.task.content), [props.task.content]);
  return /*#__PURE__*/jsx("div", {
    className: wrapper,
    "data-page-context": pageContext,
    children: /*#__PURE__*/jsx("div", {
      className: scroller,
      children: /*#__PURE__*/jsxs("table", {
        ref: tableRef,
        className: table,
        children: [/*#__PURE__*/jsx("thead", {
          className: thead,
          children: /*#__PURE__*/jsx("tr", {
            children: props.task.tableColumnHeadings.map((heading, index) => /*#__PURE__*/jsx("th", {
              className: cx(cell, tableHeadingCell),
              children: /*#__PURE__*/jsx("span", {
                className: cellContent,
                "data-alignment": heading.style.align,
                children: heading.text
              })
            }, index))
          })
        }), /*#__PURE__*/jsx("tbody", {
          children: rows.map((row, index) => /*#__PURE__*/jsx(Row, {
            inputs: row,
            taskEntryKey: props.taskEntryKey
          }, index))
        })]
      })
    })
  });
}

export { WriteAnswersInTableTask };
//# sourceMappingURL=_task.in-table.js.map
